import errorManager from '@/rollbar.js';

const init = () => {
  try {
    window.BTSwitch.switchInit('.js-switch');
  } catch (e) {
    errorManager(e);
  }
};

window.parameters = {
  init,
};
